<template>
    <div class="row">
        <div class="col-12">
            <h2 class="titre">
                Classement des dossiers - Type
            </h2>
        </div>
    </div>
    <CriteresRechercheType ref="criteresRechercheType" @rechercher="rechercher" @fermer="fermer"/>
    <ResultatRechercheType :types="types" :isRechercheDataLoading="isRechercheDataLoading"/>
</template>

<script>
import ResultatRechercheType from "@/components/pilotage/ClassementDeDossier/ResultatRechercheType.vue";
import CriteresRechercheType from "@/components/pilotage/ClassementDeDossier/CriteresRechercheType.vue";
import {mapGetters} from "vuex";
import axios from "axios";

export default {
    name: "RechercherType",
    components: { CriteresRechercheType, ResultatRechercheType},
    computed: {
        ...mapGetters({
            jeton: 'cardex/jeton',
            profil: 'cardex/profil',
        })
    },
    data() {
        return {
            isRechercheDataLoading: false,
            types: []
        }
    },
    mounted() {
      this.entite = Number(this.$route.params.entite)
      this.genre = Number(this.$route.params.genre)
      this.nature = Number(this.$route.params.nature)
        axios.defaults.headers.common['cleProfil'] = this.profil.cle;
        this.$root.$refs.breadcrumbComp.ajout("Recherche Type");
    },
    methods: {
        rechercher(libelleRecherche) {

            this.types = [];
            this.isRechercheDataLoading = true;

            this.$store.dispatch("pilotage/rechercherTableValeurAvecAscAction", libelleRecherche).then((res) => {
                res.data.libelles.forEach((currentEntite) => {
                    currentEntite.tableValeur.libelles.forEach((currentGenre) => {
                        currentGenre.tableValeur.libelles.forEach((currentNature) => {
                            currentNature.tableValeur.libelles.forEach((currentType) => {
                                let currentTypeComplete = currentType;
                                currentTypeComplete.entite = currentEntite.tableValeur.cle
                                currentTypeComplete.entiteDescription = currentEntite.tableValeur.description;
                                currentTypeComplete.genre = currentGenre.tableValeur.cle
                                currentTypeComplete.genreDescription = currentGenre.tableValeur.description;
                                currentTypeComplete.nature = currentNature.tableValeur.cle;
                                currentTypeComplete.natureDescription = currentNature.tableValeur.description;
                                this.types.push(currentTypeComplete)
                            })
                        })
                    })
                })
                this.isRechercheDataLoading = false;
            });
        },
        fermer() {
            this.$root.$refs.breadcrumbComp.rediriger();
        },
    }
}
</script>